export default "__VITE_ASSET__72J0VEm1__"